"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const DomNode = (0, vue_1.defineComponent)({
    name: 'DomNode',
    components: {},
    props: {
        nodeState: {
            type: Object,
            required: true,
        },
        indent: Number,
        hiddenNodeGroups: {
            type: Object,
            required: true,
        },
    },
    emits: [],
    computed: {
        openTag() {
            return `<${this.nodeState.tagName}`;
        },
        closeTag() {
            return `</${this.nodeState.tagName}>`;
        },
        classes() {
            const classes = [...this.nodeState.classes];
            if (this.nodeState.changes.classes) {
                for (const removed of this.nodeState.changes.classes.removed) {
                    classes.push(removed);
                }
            }
            return classes;
        },
        children() {
            const children = this.nodeState.children;
            if (this.nodeState.contentDocument) {
                children.push(...this.nodeState.contentDocument.children);
            }
            return children;
        },
        styles() {
            const styles = [...this.nodeState.styles];
            if (this.nodeState.changes.styles) {
                for (const removed of this.nodeState.changes.styles.removed) {
                    styles.push(removed);
                }
            }
            return styles.map(([name, value]) => ({ name, value }));
        },
        attributes() {
            const attrs = [...this.nodeState.attributes];
            if (this.nodeState.changes.attrs) {
                for (const removed of this.nodeState.changes.attrs.removed) {
                    attrs.push(removed);
                }
            }
            return attrs.map(([name, value]) => ({ name, value }));
        },
        properties() {
            const props = [...this.nodeState.properties];
            if (this.nodeState.changes.props) {
                for (const removed of this.nodeState.changes.props.removed) {
                    props.push(removed);
                }
            }
            return props.map(([name, value]) => ({ name, value }));
        },
        isCollapsible() {
            if (this.nodeState.isDocument || this.nodeState.isDoctype || this.nodeState.isShadowRoot)
                return false;
            if (this.nodeState.isTextNode && this.nodeState.isMultiline)
                return true;
            return this.nodeState.hasElementChildren;
        },
        isCollapsed() {
            if (this.nodeState.isManuallyExpanded === true)
                return false;
            if (this.nodeState.isManuallyExpanded === false)
                return true;
            if (this.isCollapsible === false)
                return false;
            return !this.nodeState.hasTreeChanges;
        },
        isGroupCollapsed() {
            if (!this.collapseGroupId)
                return false;
            return this.hiddenNodeGroups.isExpandedByGroupId.get(this.collapseGroupId) !== true;
        },
        isInlineTag() {
            if (this.nodeState.isComment)
                return false;
            if (this.nodeState.isTextNode)
                return !this.nodeState.isMultiline;
            if (!this.nodeState.hasElementChildren)
                return true;
            if (this.nodeState.childNodeIds.length === 1 && this.nodeState.children[0]?.isMultiline) {
                return false;
            }
            return this.isCollapsed;
        },
        indentPx() {
            return `${this.indent * 5}px`;
        },
        collapseGroupId() {
            return this.hiddenNodeGroups.collapsedGroupIdByFrameNodeId.get(this.nodeState.frameNodeId);
        },
        createdCollapseGroupId() {
            return this.hiddenNodeGroups.createdGroupIdByFrameNodeId.get(this.nodeState.frameNodeId);
        },
    },
    setup(props) { },
    methods: {
        openCollapseGroup() {
            this.hiddenNodeGroups.isExpandedByGroupId.set(this.collapseGroupId, true);
        },
    },
    beforeUnmount() { },
});
exports.default = DomNode;
